export const lettersRegex = /^[a-zA-Z]*$/;
